import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';

@Injectable()
export class BanService {

  uri = environment.protocol + '://' + environment.hostName;

  constructor(private http: HttpClient) { }

  searchVille(query: any) {
    const obj = {
      query
    };
    return this.http.post(`${this.uri}/ban/get/ville`, obj).pipe(
      map(response => {
        const dataResponse: any = response;
        const tabForFinal = [];
        if (JSON.parse(dataResponse).title === undefined) {
          for (const entry of JSON.parse(dataResponse).features) {
            const newVille = {
              name: entry.properties.name,
              postcode: entry.properties.postcode,
              libelle: entry.properties.name + ' (' + entry.properties.postcode + ')'
            };
            tabForFinal.push(newVille);
          }
          return tabForFinal;
        }
      })
    );
  } // fin searchVille

  searchAdresse(query: any) {
    const obj = {
      query
    };
    return this.http.post(`${this.uri}/ban/get/adresse`, obj).pipe(
      map(response => {
        const dataResponse: any = response;
        const tabForFinal = [];
        if (dataResponse && dataResponse.features) {
          for (const entry of dataResponse.features) {
            tabForFinal.push({
              libelle: entry.properties.label,
              // details: entry.properties // pour récupérer tout si nécessaire
            });
          }
        }
        return tabForFinal;
        /*if (JSON.parse(dataResponse).code === undefined) {
          for (const entry of JSON.parse(dataResponse).features) {
            const newAdresse = {
              libelle: entry.properties.label
            };
            tabForFinal.push(newAdresse);
          }
          return tabForFinal;
        }*/
      })
    );
  } // fin searchAdresse

}
